module.exports = __webpack_public_path__ + "img/mq.d2c60ecf.svg";